export const addresses = {
  matrixGenerator:"0x9bDD64340D3CE0607f51bBC7508CA40D45849ab8",
  contractArt:"0xB354ECF032e9e14442bE590D9Eaee37d2924B67A",
  contractCircleStencil:"0xC54051689e0931FdCF3e708b665f521f7ab42Fb0",
  contractStencil:"0x00436c9F57dfFd96cECd129c04D9E488c57266cF",
  contractGlassesStencil:"0xe4a4B3Bc2787aA913e5b4bbce907e8b213250BDe",
}
